import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/plus-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M352 240V272C352 278.6 346.6 284 340 284H252V372C252 378.6 246.6 384 240 384H208C201.4 384 196 378.6 196 372V284H108C101.4 284 96 278.6 96 272V240C96 233.4 101.4 228 108 228H196V140C196 133.4 201.4 128 208 128H240C246.6 128 252 133.4 252 140V228H340C346.6 228 352 233.4 352 240zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM400 426V86C400 82.7 397.3 80 394 80H54C50.7 80 48 82.7 48 86V426C48 429.3 50.7 432 54 432H394C397.3 432 400 429.3 400 426z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/plus-square.js
// module id = 0Kqm
// module chunks = 144